// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Infrastructure
import { UsersAPI } from "views/Users/infrastructure";
// Application
import { ElementsHandleAPI } from "vendor/application/handleMethods";
// Vendor
import {
  getRolesTypes,
  getUserBody,
  idExist,
  returnElementFromArray,
  userLangObject
} from "vendor/application";
import { showNotify } from "vendor/application/disptach";
// Components
import PasswordInput from "components/Input/PasswordInput/password_input";
import { Button, Input, SelectSimple } from "@components/Input";
import RolesCampaigns from "./roles_campaigns";
import RolesCustomers from "./roles_customers";
import RolesDesk from "./roles_desk";
// Material UI
import { CircularProgress, Divider } from "@material-ui/core";
// Translations
import { withTranslation } from "react-i18next";
// Styles
import "../styles/index.scss";
// Amplitude API
import { AmplitudeAPI } from "@api/Amplitude";

class UserEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: getUserBody(this.props.i18n.language),
      roles: getRolesTypes(),
      projects_select: [],
      projects_input: [],
      all_project: [],
      lang: userLangObject(),
      is_password_valid: false,
      tr: "",
      country: "",
      countries: [],
      timezone: ""
    };
  }

  componentDidMount = async () => {
    await this.getCountries();
    this.handleProjects();
  };

  getCountries = async () => {
    const { access, actualProject } = this.props.data;
    try {
      const newobj = new UsersAPI(actualProject.id, access, this.props);
      const countriesFromAPI = await newobj.get_countries();
      this.setState({ countries: countriesFromAPI });
    } catch (err) {
      this.setState({ countries: [] });
    }
  };

  getRoleName = (id) => {
    var element = returnElementFromArray(id, this.state.roles, "id");
    if (element) {
      return element.name;
    } else return "";
  };

  // redirect route to list from layout
  returnToList = () => {
    const { location, history } = this.props;
    var url = location.pathname.replace("/create", "");
    history.push(url);
  };

  // update element state
  updateElement = (e, type, i) => {
    const { user } = this.state;
    const obj = new ElementsHandleAPI(user, e.target.value, type, i);
    const res = obj.updateObj();

    this.setState({ user: res });
  };

  // update user
  createUser = async (e) => {
    e.preventDefault();
    const { access, actualProject, user, device_id } = this.props.data;

    if (!this.state.user.roles.length > 0) {
      this.props.dispatch(
        showNotify({ message: "roles", from: "users", severity: "error" })
      );
    } else {
      try {
        const obj = new UsersAPI(
          actualProject.id,
          access,
          this.props,
          this.state.user
        );
        await obj.post_user();

        new AmplitudeAPI({
          event_type: "User created",
          device_id: device_id,
          user_id: user.email,
          event_properties: {
            role: this.getRoleName(this.state.user.roles[0]),
            email: this.state.user.email
          }
        }).eventLog();

        this.props.dispatch(
          showNotify({ from: "users", type: "create", severity: "success" })
        );
        this.returnToList();
      } catch (err) {
        this.props.dispatch(
          showNotify({ message: err, from: "users", severity: "error" })
        );
      }
    }
  };

  isChecked = (type) => {
    const { roles, user } = this.state;
    var roleID = user.roles[0];
    var val = false;
    roles.forEach((role) => {
      if (role.id === roleID && role.name === type) {
        val = true;
      }
    });
    return val;
  };

  updateRoles = (type) => {
    const { user } = this.state;
    var el;

    if (type !== "Agent") {
      user.desk.access.only_assignee_tickets = false;
    }

    if (["Agent", "Supervisor"].includes(type)) {
      user.projects = [];
      this.setState({
        projects_select: [],
        projects_input: JSON.parse(JSON.stringify(this.props.data.projects))
      });
    }
    el = returnElementFromArray(type, this.state.roles, "name");
    user.roles = [];
    user.roles.push(el.id);

    this.setState({ user: user }, () => {
      if (type === 'Administrator') {
        this.handleProjects();
      }
    });
  };

  updateDeskAccess = () => {
    const { user } = this.state;
    user.desk.access.only_assignee_tickets =
      !user.desk.access.only_assignee_tickets;
    this.setState({ user: user });
  };

  updatePermissionsCustomers = (type) => {
    const { user } = this.state;
    user.desk.permissions.customers[type] =
      !user.desk.permissions.customers[type];
    this.setState({ user: user });
  };

  updatePermissionsCampaigns = (type) => {
    const { user } = this.state;
    user.campaigns.access[type] = !user.campaigns.access[type];
    this.setState({ user: user });
  };

  handleProjects = () => {
    const { user } = this.state;

    var pr = [];
    var pr_2 = JSON.parse(JSON.stringify(this.props.data.projects.active));

    user.projects.forEach((el) => {
      var element = returnElementFromArray(el, pr_2, "id");
      if (element) {
        pr.push(element);
        var i = idExist(element.id, pr_2, true);
        if (i !== false) {
          pr_2.splice(i, 1);
        }
      }
    });

    this.setState({
      all_projects: this.props.data.projects.active,
      projects_select: pr,
      projects_input: pr_2
    });
  };

  handleInput = (name) => {
    const { all_projects, projects_input, projects_select, user } = this.state;
    var element = returnElementFromArray(name, all_projects, "name");
    var i = idExist(element.id, projects_input, true);
    projects_select.push(element);
    projects_input.splice(i, 1);

    var a = [];
    projects_select.forEach((project_element) => {
      a.push(project_element.id);
    });

    user.projects = a;

    this.setState({
      projects_select: projects_select,
      projects_input: projects_input,
      user: user
    });
  };

  handleDelete = (el) => {
    const { projects_input, projects_select, user } = this.state;
    var i = idExist(el.id, projects_select, true);
    projects_select.splice(i, 1);
    projects_input.push(el);

    var a = [];
    projects_select.forEach((project_element) => {
      a.push(project_element.id);
    });

    user.projects = a;

    this.setState({
      projects_select: projects_select,
      projects_input: projects_input,
      user: user
    });
  };

  changeLanguage = (lang) => {
    const { user } = this.state;
    user.lang = lang;
    this.setState({ user: user });
  };

  getCountryOptions = () => {
    const { t } = this.props;
    return this.state.countries
      .map((c) => ({
        value: c.name,
        label: t(`countries:countries.${c.name}`)
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  getTimezoneOptions = (countryName) => {
    const { t } = this.props;
    const countryObj = this.state.countries.find(c => c.name === countryName);
    if (!countryObj) return [];

    return countryObj.timezones
      .map(tz => ({
        value: tz,
        label: t(`countries:timezones.${tz}`, tz)
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  changeCountry = (selectedCountry) => {
    const countryObj = this.state.countries.find(c => c.name === selectedCountry);
    const defaultTimezone = countryObj?.timezones?.[0] ?? "";

    this.setState((prevState) => ({
      country: selectedCountry,
      timezone: defaultTimezone,
      user: {
        ...prevState.user,
        timezone: defaultTimezone
      }
    }));
  };

  changeTimezone = (selectedTimezone) => {
    this.setState((prevState) => ({
      timezone: selectedTimezone,
      user: {
        ...prevState.user,
        timezone: selectedTimezone
      }
    }));
  };

  isDisabled = () => {
    const { user, is_password_valid } = this.state;

    var res = false;

    Object.keys(user).forEach((el) => {
      switch (typeof user[el]) {
        case "string":
          if (!user[el]) {
            res = true;
          }
          break;
        case "object":
          if (
            el === "projects" &&
            (this.isChecked("Supervisor") || this.isChecked("Agent"))
          )
            if (
              user[el].length === 0 &&
              el === "projects" &&
              !this.isChecked("Supervisor") &&
              !this.isChecked("Agent")
            ) {
              res = true;
            }
          break;
      }
    });

    if (!is_password_valid) {
      res = true;
    }

    return res;
  };

  updateValidity = (isValid) => {
    this.setState({ is_password_valid: isValid });
  };

  handleRoles = () => {
    const { user, plan } = this.props.data,
      role = user.role_name;
    const isAdminAndCentrideskFalse =
      user.role_name === "Administrator" && !plan.platform.centridesk;
    if (isAdminAndCentrideskFalse) {
      return [];
    }
    const isSuperAdministratorCentrideskFalse =
      user.role_name === "SuperAdministrator" && !plan.platform.centridesk;
    if (isSuperAdministratorCentrideskFalse) {
      return ["Administrator"];
    }

    switch (role) {
      case "Supervisor":
        return ["Agent"];
      case "Administrator":
        return ["Agent", "Supervisor"];
      case "SuperAdministrator":
        return ["Administrator", "Agent", "Supervisor"];
      default:
        return [];
    }
  };

  render() {
    const { user, projects_select, projects_input, country } = this.state;
    const { isSending } = this.props.data;
    const { t } = this.props;
    const isSupervisor = this.props.data.user.role_name === "Supervisor",
      role_name = this.getRoleName(user ? user?.roles[0] : "");
    return (
      user && (
        <React.Fragment>
          <div className="card">
            <div className="header-container">
              <div className="info">
                <span className={"title"}>
                  {t("users.content.title_create")}
                </span>
              </div>
              <div className="actions">
                <Button
                  id={"return_btn_users"}
                  type={"primary"}
                  onClick={(e) => this.returnToList(e)}
                  text={t("inputs:button.return")}
                />
                {isSending ? (
                  <Button
                    id={"create_btn_users"}
                    type={"primary"}
                    text={<CircularProgress size={21} />}
                  />
                ) : (
                  <Button
                    id={"create_btn_users"}
                    disabled={this.isDisabled()}
                    type={"primary"}
                    onClick={(e) => this.createUser(e)}
                    text={t("users.content.button_create")}
                  />
                )}
              </div>
            </div>
            <div className="content">
              <Divider />
              {/* FIRST NAME */}
              <div className={"elements_custom"}>
                <div className={"elements_custom__info"}>
                  <span className={"elements_custom__title"}>
                    {t("users.content.first_name")}
                  </span>
                </div>
                <Input
                  id={"firstname_input_users"}
                  placeholder={t("users.content.first_name")}
                  value={user.first_name}
                  onChange={(e) => this.updateElement(e, "first_name")}
                />
              </div>
              <Divider />
              {/* LAST NAME */}
              <div className={"elements_custom"}>
                <div className={"elements_custom__info"}>
                  <span className={"elements_custom__title"}>
                    {t("users.content.last_name")}
                  </span>
                </div>
                <Input
                  id={"last_name_input_users"}
                  placeholder={t("users.content.last_name")}
                  value={user.last_name}
                  onChange={(e) => this.updateElement(e, "last_name")}
                />
              </div>
              <Divider />
              {/* LANG */}
              <div className={"elements_custom"}>
                <div className={"elements_custom__info"}>
                  <span className={"elements_custom__title"}>
                    {t("users.content.lang")}
                  </span>
                </div>
                <SelectSimple
                  valueSelected={t(`languages:languages.${user.lang}`)}
                  items={userLangObject()}
                  onSelect={this.changeLanguage}
                  value={"value"}
                  className={"select_secondary"}
                  placeholder={t("inputs:selector.language_text")}
                  translate_pattern={"languages:languages."}
                  type={"translate"}
                  t={t}
                />
              </div>
              <Divider />
              {/* COUNTRY */}
              <div className="elements_custom">
                <div className="elements_custom__info">
                  <span className="elements_custom__title">{t("users.content.country")}</span>
                </div>
                <SelectSimple
                  valueSelected={country}
                  items={this.getCountryOptions()}
                  onSelect={this.changeCountry}
                  value={"value"}
                  className="select_secondary"
                  placeholder={t("inputs:selector.country_text")}
                  translate_pattern={"countries:countries."}
                  type="translate_selected"
                  t={t}
                />
              </div>
              <Divider />
              {/* TIMEZONE */}
              <div className="elements_custom">
                <div className="elements_custom__info">
                  <span className="elements_custom__title">{t("users.content.timezone")}</span>
                </div>
                <SelectSimple
                  valueSelected={user.timezone || "UTC"}
                  items={this.getTimezoneOptions(country)}
                  onSelect={this.changeTimezone}
                  value={"value"}
                  disabled={!country}
                  className="select_secondary"
                  placeholder={t("inputs:selector.timezone_text")}
                  translate_pattern={"countries:timezones."}
                  type="translate_selected"
                  t={t}
                />
              </div>
              <Divider />
              {/* EMAIL */}
              <div className={"elements_custom"}>
                <div className={"elements_custom__info"}>
                  <span className={"elements_custom__title"}>
                    {t("users.content.email")}
                  </span>
                </div>
                <Input
                  id={"email_input_users"}
                  placeholder={t("users.content.email")}
                  value={user.email}
                  onChange={(e) => this.updateElement(e, "email")}
                />
              </div>
              <Divider />
              {/* PASSWORD */}
              <div className={"elements_custom"}>
                <div className={"elements_custom__info"}>
                  <span className={"elements_custom__title"}>
                    {t("users.content.password")}
                  </span>
                </div>
                <PasswordInput
                  updateValidity={this.updateValidity}
                  value={user.password}
                  field={"password"}
                  onChange={this.updateElement}
                />
              </div>
              <Divider />
              {/* ROLES */}
              <div className={"elements_custom elements_custom__roles"}>
                <div className={"elements_custom__info"}>
                  <span className={"elements_custom__title"}>
                    {t("users.content.roles")}
                  </span>
                </div>
                <div className="switch">
                  <SelectSimple
                    valueSelected={
                      role_name ? t(`inputs:switch.roles.${role_name}`) : false
                    }
                    items={this.handleRoles()}
                    onSelect={this.updateRoles}
                    className={"select_secondary"}
                    placeholder={t("inputs:switch.roles.placeholder")}
                    translate_pattern={"inputs:switch.roles."}
                    type={"translate"}
                    t={t}
                  />
                  {this.isChecked("Agent") && (
                    <RolesDesk
                      user={JSON.parse(JSON.stringify(user))}
                      updateAction={this.updateDeskAccess}
                    />
                  )}
                  {this.isChecked("Agent") && (
                    <RolesCustomers
                      user={JSON.parse(JSON.stringify(user))}
                      updateAction={this.updatePermissionsCustomers}
                    />
                  )}
                  {this.isChecked("Agent") && (
                    <RolesCampaigns
                      user={JSON.parse(JSON.stringify(user))}
                      updateAction={this.updatePermissionsCampaigns}
                    />
                  )}
                  {this.isChecked("Supervisor") && (
                    <RolesCampaigns
                      user={JSON.parse(JSON.stringify(user))}
                      updateAction={this.updatePermissionsCampaigns}
                    />
                  )}
                </div>
              </div>
              {/* PROJECTS */}
              {!this.isChecked("Supervisor") &&
                !this.isChecked("Agent") &&
                !isSupervisor && (
                  <React.Fragment>
                    <Divider />
                    <div className={"elements_custom"}>
                      <div className={"elements_custom__info"}>
                        <span className={"elements_custom__title"}>
                          {t("users.content.projects")}
                        </span>
                        <span className={"elements_custom__description"}>
                          {t("users.content.projects_description")}
                        </span>
                      </div>
                      <div className={"platform_input_content"}>
                        <SelectSimple
                          valueSelected={t("users.content.projects")}
                          items={projects_input}
                          onSelect={this.handleInput}
                          disabled={
                            this.isChecked("Supervisor") ||
                            this.isChecked("Agent")
                          }
                          value={"name"}
                          className={"select_secondary"}
                          placeholder={t("users.content.projects")}
                          t={t}
                        />
                        <div className={"tags"}>
                          {projects_select.length > 0 ? (
                            projects_select.map((el, i) => {
                              return (
                                <div
                                  className={"chips"}
                                  onClick={() => this.handleDelete(el)}
                                  key={i}
                                >
                                  {el.name}
                                </div>
                              );
                            })
                          ) : (
                            <span>{t("users.content.no_projects")}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
            </div>
          </div>
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(UserEdit);

export default withTranslation(["users", "inputs"])(withRouter(connect_));
